type EventCallback = (data: any) => void;

export const OK_RESPONSE = 'ok';

export type WebsocketEvents = Record<string, EventCallback>;

export type WebsocketMessage<T> = {
  id?: string;
  token?: string;
  event: string;
  data: T;
};

export type WebsocketServerResponse<T> = {
  id: string;
  data: T;
};

export type SubscribedRoom = {
  room: string;
  token?: string;
};

export type WebsocketOptions = {
  /**
   * URL of the websocket.
   */
  url?: string;

  /**
   * Sets the `binaryType` property of the underlying WebSocket.
   */
  binaryType?: 'blob' | 'arraybuffer';

  /**
   * Interval to try and reconnect.
   * Default: 5000
   */
  reconnectInterval?: number;

  /**
   * Number of reconnect attemps.
   * Default: 10
   */
  reconnectAttempts?: number;

  /**
   * Connection timeout
   * Default: 5000
   */
  timeout: number;
  
  pingInterval?: number;

  /**
   * Serializer to call before sending messages
   * Default: `json.stringify`
   */
  serializer?: (data: any) => string;

  /**
   * Deseralizer before publishing the message.
   */
  deserializer?: (e: MessageEvent) => any;
}